module.exports = __webpack_public_path__ + "img/spinner.24e1bbcf.gif";